(() => {
  window.park.observer.initialize('.park-card-topic', (elem) => {
    window.park.lazyLoad(elem.querySelector('.park-card-topic__articles'));
  }, false);
})();
